import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { Vault, VAULTS } from 'data/Vaults';
import { lowercaseFirstChar } from 'utils/str';

type VaultState = Vault & {
	exchange: string;
	network?: string;
	selectedToken: string;
};

const initialState: VaultState = {
	...VAULTS.HypeEvm[0],
	exchange: 'hypeEvm',
	network: undefined,
	selectedToken: VAULTS.HypeEvm[0].token[0].name,
};

export const vaultSlice = createSlice({
	name: 'vault',
	initialState,
	reducers: {
		changeVault: (
			state: Draft<VaultState>,
			action: PayloadAction<Vault>,
		) => {
			state.exchange = lowercaseFirstChar(
				action.payload.exchanger[0].name,
			);
			state.network = action.payload.exchanger[0]?.network
				? action.payload.exchanger[0]?.network[0]?.name
				: undefined;
			state.selectedToken = action.payload.token[0].name;
			Object.assign(state, action.payload);
		},

		changeExchange: (
			state: Draft<VaultState>,
			action: PayloadAction<string>,
		) => {
			state.exchange = action.payload;
		},
		changeNetwork: (
			state: Draft<VaultState>,
			action: PayloadAction<string>,
		) => {
			state.network = action.payload;
		},
	},
});

export const vaultActions = vaultSlice.actions;
const vaultReducer = vaultSlice.reducer;
export default vaultReducer;
